@use '../../../utils.scss';

.ActionBtn {
	border-radius: 8px;
	background-color: utils.color('nebula');
	color: white;
	cursor: pointer;
	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
    &:hover {
       background-color: _color('nebula-light');
    }
}
